import { Token } from "./token";
import { DateG6k } from "../date/date-g6k";

export class Expression {

    constructor(expression) {
        this.expression = expression;
        this.tokens = [];
        this.postfixed = false;
    }

    get() {
        return this.tokens;
    }

    push(t) {
        this.tokens.push(t);
    }

    pop() {
        return this.tokens.pop();
    }

    peek() {
        return this.tokens[this.tokens.length - 1];
    }

    postfix() {
        var stack = [];
        var rpn = [];

        $.each(this.tokens, function (t, token) {
            switch (token.type) {
                case Token.TYPE.T_COMMA:
                    while (stack.length != 0 && stack[stack.length - 1].type != Token.TYPE.T_POPEN) {
                        rpn.push(stack.pop());
                    }
                    if (stack.length > 1
                        && stack[stack.length - 2].type == Token.TYPE.T_FUNCTION) {
                        stack[stack.length - 2].arity++;
                    }
                    break;
                case Token.TYPE.T_NUMBER:
                case Token.TYPE.T_DATE:
                case Token.TYPE.T_BOOLEAN:
                case Token.TYPE.T_TEXT:
                case Token.TYPE.T_ANY:
                case Token.TYPE.T_IDENT:
                case Token.TYPE.T_FIELD:
                case Token.TYPE.T_ARRAY:
                case Token.TYPE.T_UNDEFINED:
                    rpn.push(token);
                    break;
                case Token.TYPE.T_PCLOSE:
                    while (stack.length != 0 && stack[stack.length - 1].type != Token.TYPE.T_POPEN) {
                        rpn.push(stack.pop());
                    }
                    if (stack.length == 0) {
                        throw new Error("Closing parenthesis without opening parenthesis");
                    }
                    stack.pop();
                    if (stack.length != 0
                        && stack[stack.length - 1].type == Token.TYPE.T_FUNCTION) {
                        stack[stack.length - 1].arity++;
                        rpn.push(stack.pop());
                    }
                    break;
                case Token.TYPE.T_POPEN:
                case Token.TYPE.T_FUNCTION:
                    stack.push(token);
                    break;
                default:
                    if (token.isOperator() || token.isComparator()) {
                        while (stack.length != 0
                            && (stack[stack.length - 1].isOperator() || stack[stack.length - 1].isComparator())
                            && ((token.associativity() == Token.TYPE.A_LEFT && token.precedence() >= stack[stack.length - 1].precedence()) || (token.associativity() == Token.TYPE.A_RIGHT && token.precedence() > stack[stack.length - 1].precedence()))) {
                            rpn.push(stack.pop());
                        }
                        stack.push(token);
                    } else {
                        throw new Error("Unrecognized token " + token.value);
                    }
                    break;
            }
        });
        while (stack.length != 0 && stack[stack.length - 1].type != Token.TYPE.T_POPEN) {
            rpn.push(stack.pop());
        }
        if (stack.length != 0) {
            throw new Error("Opening parenthesis without closing parenthesis");
        }
        this.tokens = rpn;
        this.postfixed = true;
    }
    // not used
    setFields(fields) {
        $.each(this.tokens, function (t, token) {
            if (token.type == Token.TYPE.T_FIELD && fields.length >= token.value) {
                var value = fields[token.value - 1];
                if ($.isArray(value)) {
                    token.type = Token.TYPE.T_ARRAY;
                    token.value = value;
                } else if ($.isNumeric(value)) {
                    token.type = Token.TYPE.T_NUMBER;
                    token.value = parseFloat(value);
                } else if (DateG6k.isDate(value)) {
                    token.type = Token.TYPE.T_DATE;
                    token.value = DateG6k.createFromFormat(DateG6k.inputFormat, value);
                } else if (value === 'true' || value === 'false') {
                    token.type = Token.TYPE.T_BOOLEAN;
                    token.value = value === 'true';
                } else {
                    token.type = Token.TYPE.T_TEXT;
                    token.value = value;
                }
            }
        });
    }
    // not used
    setNamedFields(fields) {
        $.each(this.tokens, function (t, token) {
            if (token.type == Token.TYPE.T_IDENT && typeof fields[token.value] !== 'undefined' && fields[token.value] !== null) {
                var value = fields[token.value];
                if ($.isArray(value)) {
                    token.type = Token.TYPE.T_ARRAY;
                    token.value = value;
                } else if ($.isNumeric(value)) {
                    token.type = Token.TYPE.T_NUMBER;
                    token.value = parseFloat(value);
                } else if (DateG6k.isDate(value)) {
                    token.type = Token.TYPE.T_DATE;
                    token.value = DateG6k.createFromFormat(DateG6k.inputFormat, value);
                } else if (value === 'true' || value === 'false') {
                    token.type = Token.TYPE.T_BOOLEAN;
                    token.value = value === 'true';
                } else {
                    token.type = Token.TYPE.T_TEXT;
                    token.value = value;
                }
            }
        });
    }

    setVariables(variables) {
        var completed = true;
        $.each(this.tokens, function (t, token) {
            if (token.type == Token.TYPE.T_FIELD) {
                var value = variables['' + token.value];
                if (typeof value === 'undefined' || value === null || value.length == 0) {
                    completed = false;
                } else if ($.isArray(value)) {
                    token.type = Token.TYPE.T_ARRAY;
                    token.value = value;
                } else if ($.isNumeric(value)) {
                    token.type = Token.TYPE.T_NUMBER;
                    token.value = parseFloat(value);
                } else if (DateG6k.isDate(value)) {
                    token.type = Token.TYPE.T_DATE;
                    token.value = DateG6k.createFromFormat(DateG6k.inputFormat, value);
                } else if (value === 'true' || value === 'false') {
                    token.type = Token.TYPE.T_BOOLEAN;
                    token.value = value === 'true';
                } else {
                    token.type = Token.TYPE.T_TEXT;
                    token.value = value;
                }
            } else if (token.type == Token.TYPE.T_IDENT) {
                var value = variables[token.value];
                if (typeof value === 'undefined' || value === null || value.length == 0) {
                    completed = false;
                } else if ($.isArray(value)) {
                    token.type = Token.TYPE.T_ARRAY;
                    token.value = value;
                } else if ($.isNumeric(value)) {
                    token.type = Token.TYPE.T_NUMBER;
                    token.value = parseFloat(value);
                } else if (DateG6k.isDate(value)) {
                    token.type = Token.TYPE.T_DATE;
                    token.value = DateG6k.createFromFormat(DateG6k.inputFormat, value);
                } else if (value === 'true' || value === 'false') {
                    token.type = Token.TYPE.T_BOOLEAN;
                    token.value = value === 'true';
                } else {
                    token.type = Token.TYPE.T_TEXT;
                    token.value = value;
                }
            }
        });
        return completed;
    }

    evaluate() {
        try {
            var ops = [];
            var self = this;
            $.each(this.tokens, function (t, token) {
                if (token.isOperator()) {
                    ops.push(self.operation(token, ops));
                } else if (token.isComparator()) {
                    ops.push(self.comparison(token, ops));
                } else {
                    switch (token.type) {
                        case Token.TYPE.T_NUMBER:
                        case Token.TYPE.T_DATE:
                        case Token.TYPE.T_BOOLEAN:
                        case Token.TYPE.T_TEXT:
                        case Token.TYPE.T_ANY:
                        case Token.TYPE.T_IDENT:
                        case Token.TYPE.T_FIELD:
                        case Token.TYPE.T_ARRAY:
                        case Token.TYPE.T_UNDEFINED:
                            ops.push(token);
                            break;
                        case Token.TYPE.T_FUNCTION:
                            ops.push(self.func(token, ops));
                            break;
                        default:
                            throw new Error("Unrecognized token " + token.value);
                    }
                }
            });
            var result = ops[ops.length - 1];
            return result.isVariable() ? false : '' + result;
        } catch (e) {
            console.error(e);
            return false;
        }
    }

    operation(op, args) {
        if (op.isUnaryOperator()) {
            if (args.length < 1) {
                throw new Error("Illegal number (" + args.length + ") of operands for " + op);
            }
            var arg1 = args.pop();
        } else if (op.isBinaryOperator()) {
            if (args.length < 2) {
                throw new Error("Illegal number (" + args.length + ") of operands for " + op);
            }
            var arg2 = args.pop();
            var arg1 = args.pop();
        } else if (op.isTernaryOperator()) {
            if (args.length < 3) {
                throw new Error("Illegal number (" + args.length + ") of operands for " + op);
            }
            var arg3 = args.pop();
            var arg2 = args.pop();
            var arg1 = args.pop();
        }
        var result = new Token(Token.TYPE.T_NUMBER, 0);
        switch (op.type) {
            case Token.TYPE.T_PLUS:
                if (arg1.isVariable() || arg2.isVariable()) {
                    result.type = Token.TYPE.T_UNDEFINED;
                    result.value = [arg1, arg2];
                } else if (arg1.type == Token.TYPE.T_NUMBER) {
                    if (arg2.type == Token.TYPE.T_NUMBER) {
                        result.value = arg1.value + arg2.value;
                    } else if (arg2.type == Token.TYPE.T_DATE) {
                        var date = arg2.value;
                        date.addDays(arg1.value);
                        result.type = Token.TYPE.T_DATE;
                        result.value = date;
                    } else if (arg2.type == Token.TYPE.T_TEXT) {
                        result.type = Token.TYPE.T_TEXT;
                        result.value = arg1.value.toString() + arg2.value;
                    } else {
                        throw new Error("Illegal argument '" + arg2 + "' for " + op);
                    }
                } else if (arg1.type == Token.TYPE.T_DATE) {
                    if (arg2.type == Token.TYPE.T_NUMBER) {
                        var date = arg1.value;
                        date.addDays(arg2.value);
                        result.type = Token.TYPE.T_DATE;
                        result.value = date;
                    } else if (arg2.type == Token.TYPE.T_TEXT) {
                        result.type = Token.TYPE.T_TEXT;
                        result.value = arg1.value.format(DateG6k.format) + arg2.value;
                    } else {
                        throw new Error("Illegal argument '" + arg2 + "' for " + op);
                    }
                } else if (arg1.type == Token.TYPE.T_TEXT) {
                    result.type = Token.TYPE.T_TEXT;
                    if (arg2.type == Token.TYPE.T_NUMBER) {
                        result.value = arg1.value + arg2.value.toString();
                    } else if (arg2.type == Token.TYPE.T_DATE) {
                        result.value = arg1.value + arg2.value.format(DateG6k.format);
                    } else if (arg2.type == Token.TYPE.T_TEXT) {
                        result.value = arg1.value + arg2.value;
                    } else {
                        throw new Error("Illegal argument '" + arg2 + "' for " + op);
                    }
                } else {
                    throw new Error("Illegal argument '" + arg1 + "' for " + op);
                }
                break;
            case Token.TYPE.T_MINUS:
                if (arg1.isVariable() || arg2.isVariable()) {
                    result.type = Token.TYPE.T_UNDEFINED;
                    result.value = [arg1, arg2];
                } else if (arg1.type == Token.TYPE.T_NUMBER) {
                    if (arg2.type == Token.TYPE.T_NUMBER) {
                        result.value = arg1.value - arg2.value;
                    } else {
                        throw new Error("Illegal argument '" + arg2 + "' for " + op);
                    }
                } else if (arg1.type == Token.TYPE.T_DATE) {
                    if (arg2.type == Token.TYPE.T_NUMBER) {
                        var date = arg1.value;
                        date.addDays(-arg2.value);
                        result.type = Token.TYPE.T_DATE;
                        result.value = date;
                    } else if (arg2.type == Token.TYPE.T_DATE) {
                        result.value = (arg1.value > arg2.value)
                            ? arg2.value.getDaysBetween(arg1.value)
                            : 0;
                    } else {
                        throw new Error("Illegal argument '" + arg2 + "' for " + op);
                    }
                } else {
                    throw new Error("Illegal argument '" + arg1 + "' for " + op);
                }
                break;
            case Token.TYPE.T_TIMES:
                if (arg1.isVariable() || arg2.isVariable()) {
                    result.type = Token.TYPE.T_UNDEFINED;
                    result.value = [arg1, arg2];
                } else if (arg1.type != Token.TYPE.T_NUMBER || arg2.type != Token.TYPE.T_NUMBER) {
                    throw new Error("Illegal argument '" + arg2 + "' : operands must be numbers for " + op);
                } else {
                    result.value = arg1.value * arg2.value;
                }
                break;
            case Token.TYPE.T_DIV:
                if (arg1.isVariable() || arg2.isVariable()) {
                    result.type = Token.TYPE.T_UNDEFINED;
                    result.value = [arg1, arg2];
                } else if (arg1.type != Token.TYPE.T_NUMBER || arg2.type != Token.TYPE.T_NUMBER) {
                    throw new Error("Illegal argument : operands must be numbers for " + op);
                } else {
                    result.value = arg1.value / arg2.value;
                }
                break;
            case Token.TYPE.T_MOD:
                if (arg1.isVariable() || arg2.isVariable()) {
                    result.type = Token.TYPE.T_UNDEFINED;
                    result.value = [arg1, arg2];
                } else if (arg1.type != Token.TYPE.T_NUMBER || arg2.type != Token.TYPE.T_NUMBER) {
                    throw new Error("Illegal argument : operands must be numbers for " + op);
                } else {
                    result.value = arg1.value % arg2.value;
                }
                break;
            case Token.TYPE.T_POW:
                if (arg1.isVariable() || arg2.isVariable()) {
                    result.type = Token.TYPE.T_UNDEFINED;
                    result.value = [arg1, arg2];
                } else if (arg1.type != Token.TYPE.T_NUMBER || arg2.type != Token.TYPE.T_NUMBER) {
                    throw new Error("Illegal argument : operands must be numbers for " + op);
                } else {
                    result.value = Math.pow(arg1.value, arg2.value);
                }
                break;
            case Token.TYPE.T_BITWISE_AND:
                if (arg1.isVariable() || arg2.isVariable()) {
                    result.type = Token.TYPE.T_UNDEFINED;
                    result.value = [arg1, arg2];
                } else if (arg1.type != Token.TYPE.T_NUMBER || arg2.type != Token.TYPE.T_NUMBER) {
                    throw new Error("Illegal argument : operands must be numbers for " + op);
                } else {
                    result.value = arg1.value & arg2.value;
                }
                break;
            case Token.TYPE.T_BITWISE_XOR:
                if (arg1.isVariable() || arg2.isVariable()) {
                    result.type = Token.TYPE.T_UNDEFINED;
                    result.value = [arg1, arg2];
                } else if (arg1.type != Token.TYPE.T_NUMBER || arg2.type != Token.TYPE.T_NUMBER) {
                    throw new Error("Illegal argument : operands must be numbers for " + op);
                } else {
                    result.value = arg1.value ^ arg2.value;
                }
                break;
            case Token.TYPE.T_BITWISE_OR:
                if (arg1.isVariable() || arg2.isVariable()) {
                    result.type = Token.TYPE.T_UNDEFINED;
                    result.value = [arg1, arg2];
                } else if (arg1.type != Token.TYPE.T_NUMBER || arg2.type != Token.TYPE.T_NUMBER) {
                    throw new Error("Illegal argument : operands must be numbers for " + op);
                } else {
                    result.value = arg1.value | arg2.value;
                }
                break;
            case Token.TYPE.T_LOGICAL_AND:
                result.type = Token.TYPE.T_BOOLEAN;
                if (arg1.type == Token.TYPE.T_BOOLEAN && arg2.type == Token.TYPE.T_BOOLEAN) {
                    result.value = arg1.value && arg2.value;
                } else if (arg1.type == Token.TYPE.T_BOOLEAN) {
                    if (!arg1.value) {
                        result.value = false;
                    } else if (arg2.isVariable()) {
                        result.type = Token.TYPE.T_UNDEFINED;
                        result.value = [arg1, arg2];
                    } else {
                        throw new Error("Illegal argument 2 : operand must be boolean for " + op);
                    }
                } else if (arg2.type == Token.TYPE.T_BOOLEAN) {
                    if (!arg2.value) {
                        result.value = false;
                    } else if (arg1.isVariable()) {
                        result.type = Token.TYPE.T_UNDEFINED;
                        result.value = [arg1, arg2];
                    } else {
                        throw new Error("Illegal argument 1 : operand must be boolean for " + op);
                    }
                } else if (arg1.isVariable() || arg2.isVariable()) {
                    result.type = Token.TYPE.T_UNDEFINED;
                    result.value = [arg1, arg2];
                } else {
                    throw new Error("Illegal argument : operands must be boolean for " + op);
                }
                break;
            case Token.TYPE.T_LOGICAL_OR:
                result.type = Token.TYPE.T_BOOLEAN;
                if (arg1.type == Token.TYPE.T_BOOLEAN && arg2.type == Token.TYPE.T_BOOLEAN) {
                    result.value = arg1.value || arg2.value;
                } else if (arg1.type == Token.TYPE.T_BOOLEAN) {
                    if (arg1.value) {
                        result.value = true;
                    } else if (arg2.isVariable()) {
                        result.type = Token.TYPE.T_UNDEFINED;
                        result.value = [arg1, arg2];
                    } else {
                        throw new Error("Illegal argument 2 : operand must be boolean for " + op);
                    }
                } else if (arg2.type == Token.TYPE.T_BOOLEAN) {
                    if (arg2.value) {
                        result.value = true;
                    } else if (arg1.isVariable()) {
                        result.type = Token.TYPE.T_UNDEFINED;
                        result.value = [arg1, arg2];
                    } else {
                        throw new Error("Illegal argument 1 : operand must be boolean for " + op);
                    }
                } else if (arg1.isVariable() || arg2.isVariable()) {
                    result.type = Token.TYPE.T_UNDEFINED;
                    result.value = [arg1, arg2];
                } else {
                    throw new Error("Illegal argument : operands must be boolean for " + op);
                }
                break;
            case Token.TYPE.T_UNARY_PLUS:
                if (arg1.isVariable()) {
                    result.type = Token.TYPE.T_UNDEFINED;
                    result.value = [arg1];
                } else if (arg1.type != Token.TYPE.T_NUMBER) {
                    throw new Error("Illegal argument '" + arg1 + "' : operand must be a number for " + op);
                } else {
                    result.value = arg1.value;
                }
                break;
            case Token.TYPE.T_UNARY_MINUS:
                if (arg1.isVariable()) {
                    result.type = Token.TYPE.T_UNDEFINED;
                    result.value = [arg1];
                } else if (arg1.type != Token.TYPE.T_NUMBER) {
                    throw new Error("Illegal argument '" + arg1 + "' : operand must be a number for " + op);
                } else {
                    result.value = -arg1.value;
                }
                break;
            case Token.TYPE.T_NOT:
                if (arg1.isVariable()) {
                    result.type = Token.TYPE.T_UNDEFINED;
                    result.value = [arg1];
                } else if (arg1.type != Token.TYPE.T_NUMBER && arg1.type != Token.TYPE.T_BOOLEAN) {
                    throw new Error("Illegal argument '" + arg1 + "' : operand must be a number or a boolean for " + op);
                } else {
                    result.type = arg1.type;
                    result.value = !arg1.value;
                }
                break;
            case Token.TYPE.T_DEGRE:
                if (arg1.isVariable()) {
                    result.type = Token.TYPE.T_UNDEFINED;
                    result.value = [arg1];
                } else if (arg1.type != Token.TYPE.T_NUMBER) {
                    throw new Error("Illegal argument '" + arg1 + "' : operand must be a number for " + op);
                } else {
                    result.value = arg1.value * Math.PI / 180;
                }
                break;
            case Token.TYPE.T_TERNARY_ELSE:
                result = arg1;
                break;
            case Token.TYPE.T_TERNARY:
                if (arg1.isVariable()) {
                    result.type = Token.TYPE.T_UNDEFINED;
                    result.value = [arg1, arg2, arg3];
                } else if (arg1.type != Token.TYPE.T_BOOLEAN) {
                    throw new Error("Illegal argument '" + arg1 + "' : operand 1 must be a condition for " + op);
                } else {
                    result = arg1.value ? arg2 : arg3;
                }
                break;
        }
        this.guessType(result);
        return result;
    }

    comparison(op, args) {
        if (args.length < 2) {
            throw new Error("Illegal number (" + args.length + ") of operands for " + op);
        }
        var arg2 = args.pop();
        var arg1 = args.pop();
        var result;
        if (arg1.isVariable() || arg2.isVariable()) {
            result = new Token(Token.TYPE.T_UNDEFINED, [arg1, arg2]);
        } else if (op.type != Token.TYPE.T_CONTAINS && arg1.type != arg2.type) {
            throw new Error("operand types for '" + op + "' are not identical");
        } else if (op.type == Token.TYPE.T_CONTAINS && arg1.type != Token.TYPE.T_ARRAY) {
            throw new Error("first operand type for '" + op + "' is not an array");
        } else {
            result = new Token(Token.TYPE.T_BOOLEAN, false);
            switch (op.type) {
                case Token.TYPE.T_EQUAL:
                    result.value = (arg1.value == arg2.value);
                    break;
                case Token.TYPE.T_NOT_EQUAL:
                    result.value = (arg1.value != arg2.value);
                    break;
                case Token.TYPE.T_LESS_THAN:
                    result.value = (arg1.value < arg2.value);
                    break;
                case Token.TYPE.T_LESS_OR_EQUAL:
                    result.value = (arg1.value <= arg2.value);
                    break;
                case Token.TYPE.T_GREATER_THAN:
                    result.value = (arg1.value > arg2.value);
                    break;
                case Token.TYPE.T_GREATER_OR_EQUAL:
                    result.value = (arg1.value >= arg2.value);
                    break;
                case Token.TYPE.T_CONTAINS:
                    result.value = $.isArray(arg1.value) && $.inArray(arg2.value.toString(), arg1.value) >= 0;
                    break;
                case Token.TYPE.T_NOT_CONTAINS:
                    result.value = !$.isArray(arg1.value) || $.inArray(arg2.value.toString(), arg1.value) < 0;
                    break;
            }
        }
        return result;
    }

    guessType(token) {
        if (token.type == Token.TYPE.T_TEXT) {
            if ($.isNumeric(token.value)) {
                token.type = Token.TYPE.T_NUMBER;
                token.value = parseFloat(token.value);
            } else if (DateG6k.isDate(token.value)) {
                token.type = Token.TYPE.T_DATE;
                token.value = DateG6k.createFromFormat(DateG6k.inputFormat, token.value);
            } else if (token.value === 'true' || token.value === 'false') {
                token.type = Token.TYPE.T_BOOLEAN;
                token.value = token.value === 'true';
            }
        }
    }

    func(func, args) {
        var functions = {
            "abs": [1, [Token.TYPE.T_NUMBER], Token.TYPE.T_NUMBER, function (a) { return Math.abs(a); }],
            "acos": [1, [Token.TYPE.T_NUMBER], Token.TYPE.T_NUMBER, function (a) { return Math.acos(a); }],
            "acosh": [1, [Token.TYPE.T_NUMBER], Token.TYPE.T_NUMBER, function (a) { return Math.acosh(a); }],
            "addMonths": [2, [Token.TYPE.T_NUMBER, Token.TYPE.T_DATE], Token.TYPE.T_DATE, function (a, b) { return b.addMonths(a); }],
            "asin": [1, [Token.TYPE.T_NUMBER], Token.TYPE.T_NUMBER, function (a) { return Math.asin(a); }],
            "asinh": [1, [Token.TYPE.T_NUMBER], Token.TYPE.T_NUMBER, function (a) { return Math.asinh(a); }],
            "atan": [1, [Token.TYPE.T_NUMBER], Token.TYPE.T_NUMBER, function (a) { return Math.atan(a); }],
            "atan2": [2, [Token.TYPE.T_NUMBER, Token.TYPE.T_NUMBER], Token.TYPE.T_NUMBER, function (a, b) { return Math.atan2(a, b); }],
            "atanh": [1, [Token.TYPE.T_NUMBER], Token.TYPE.T_NUMBER, function (a) { return Math.atanh(a); }],
            "ceil": [1, [Token.TYPE.T_NUMBER], Token.TYPE.T_NUMBER, function (a) { return Math.ceil(a); }],
            "concat": [-1, [Token.TYPE.T_TEXT], Token.TYPE.T_TEXT, function (a) {
                var c = '';
                $.each(a, function (i, v) {
                    c += v !== undefined ? v : '';
                });
                return c;
            }],
            "cos": [1, [Token.TYPE.T_NUMBER], Token.TYPE.T_NUMBER, function (a) { return Math.cos(a); }],
            "cosh": [1, [Token.TYPE.T_NUMBER], Token.TYPE.T_NUMBER, function (a) { return Math.cosh(a); }],
            "count": [-1, [Token.TYPE.T_NUMBER], Token.TYPE.T_NUMBER, function (a) {
                var c = 0;
                $.each(a, function (i, v) {
                    if (v !== undefined) {
                        c += 1;
                    }
                });
                return c;
            }],
            "day": [1, [Token.TYPE.T_DATE], Token.TYPE.T_NUMBER, function (a) { if (a.getDate() > 9) { return a.getDate(); } else { return '0' + a.getDate() } }],
            "exp": [1, [Token.TYPE.T_NUMBER], Token.TYPE.T_NUMBER, function (a) { return Math.exp(a); }],
            "firstDayOfMonth": [1, [Token.TYPE.T_DATE], Token.TYPE.T_DATE, function (a) { return a.firstDayOfMonth(); }],
            "floor": [1, [Token.TYPE.T_NUMBER], Token.TYPE.T_NUMBER, function (a) { return Math.floor(a); }],
            "fullmonth": [1, [Token.TYPE.T_DATE], Token.TYPE.T_TEXT, function (a) { return a.getMonthName('fr') + ' ' + a.format('Y'); }],
            "fulldateletter": [1, [Token.TYPE.T_DATE], Token.TYPE.T_TEXT, function (a) {
                var tab_jour = new Array("dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi");
                return tab_jour[a.getDay()] + ' ' + a.getDate() + ' ' + a.getMonthName('fr') + ' ' + a.format('Y');
            }],
            "dayLetter": [1, [Token.TYPE.T_DATE], Token.TYPE.T_TEXT, function (a) {
                var tab_jour = new Array("dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi");
                return tab_jour[a.getDay()];
            }],
            "get": [2, [Token.TYPE.T_ARRAY, Token.TYPE.T_NUMBER], Token.TYPE.T_TEXT, function (a, b) { return b < a.lengh + 1 ? a[b - 1] : ''; }],
            "lastday": [2, [Token.TYPE.T_NUMBER, Token.TYPE.T_NUMBER], Token.TYPE.T_NUMBER, function (a, b) { var d = DateG6k.createFromFormat('Y-n-j', a + '-' + b + '-1'); return d.lastday(false); }],
            "lastDayOfMonth": [1, [Token.TYPE.T_DATE], Token.TYPE.T_DATE, function (a) { return a.lastDayOfMonth(); }],
            "datesansseparateur": [1, [Token.TYPE.T_DATE], Token.TYPE.T_DATE, function (a) { return a.getDate() + a.getMonth() + a.getFullYear(); }],
            "lcfirst": [1, [Token.TYPE.T_TEXT], Token.TYPE.T_TEXT, function (a) { return a.replace(/(^[A-Z])/, function (p) { return p.toLowerCase(); }); }],
            "length": [1, [Token.TYPE.T_TEXT], Token.TYPE.T_NUMBER, function (a) { return a.length; }],
            "log": [1, [Token.TYPE.T_NUMBER], Token.TYPE.T_NUMBER, function (a) { return Math.log(a); }],
            "log10": [1, [Token.TYPE.T_NUMBER], Token.TYPE.T_NUMBER, function (a) { return Math.log10(a); }],
            "lower": [1, [Token.TYPE.T_TEXT], Token.TYPE.T_TEXT, function (a) { return a.toLowerCase(); }],
            "match": [2, [Token.TYPE.T_TEXT, Token.TYPE.T_TEXT], Token.TYPE.T_BOOLEAN, function (a, b) { return b.match(a) != null; }],
            "max": [-1, [Token.TYPE.T_NUMBER], Token.TYPE.T_NUMBER, function (a) { return Math.max.apply(null, a); }],
            "min": [-1, [Token.TYPE.T_NUMBER], Token.TYPE.T_NUMBER, function (a) { return Math.min.apply(null, a); }],
            "money": [1, [Token.TYPE.T_NUMBER], Token.TYPE.T_TEXT, function (a) {
                return AutoNumeric.format(a, {
                    currencySymbol: '',
                    currencySymbolPlacement: MoneyFunction.symbolPosition == 'before' ? 'p' : 's',
                    decimalCharacter: MoneyFunction.decimalPoint,
                    decimalPlaces: 2,
                    digitGroupSeparator: MoneyFunction.groupingSeparator,
                    digitalGroupSpacing: MoneyFunction.groupingSize
                });
            }],
            "month": [1, [Token.TYPE.T_DATE], Token.TYPE.T_NUMBER, function (a) { if ((a.getMonth() + 1) > 9) { return a.getMonth() + 1; } else { return '0' + (a.getMonth() + 1) } }],
            "nextWorkDay": [1, [Token.TYPE.T_DATE], Token.TYPE.T_DATE, function (a) { return a.nextWorkingDay(); }],
            "pow": [2, [Token.TYPE.T_NUMBER, Token.TYPE.T_NUMBER], Token.TYPE.T_NUMBER, function (a, b) { return Math.pow(a, b); }],
            "rand": [0, [], Token.TYPE.T_NUMBER, function () { return Math.random(); }],
            "replace": [3, [Token.TYPE.T_TEXT, Token.TYPE.T_TEXT, Token.TYPE.T_TEXT], Token.TYPE.T_TEXT, function (a, b, c) {
                var d = c;
                while (d.indexOf(a) >= 0) {
                    d = d.replace(a, b);
                }
                return d;
            }],
            "round": [1, [Token.TYPE.T_NUMBER], Token.TYPE.T_NUMBER, function (a) { return Math.round(a); }],
            "sin": [1, [Token.TYPE.T_NUMBER], Token.TYPE.T_NUMBER, function (a) { return Math.sin(a); }],
            "sinh": [1, [Token.TYPE.T_NUMBER], Token.TYPE.T_NUMBER, function (a) { return Math.sinh(a); }],
            "size": [1, [Token.TYPE.T_ARRAY], Token.TYPE.T_NUMBER, function (a) { return a.length; }],
            "split": [2, [Token.TYPE.T_TEXT, Token.TYPE.T_TEXT], Token.TYPE.T_ARRAY, function (a, b) { return b.split(a); }],
            "getCodePostal": [1, [Token.TYPE.T_TEXT], Token.TYPE.T_TEXT, function(a) { return a.split('//')[0]; }],
			"getNomVille": [1, [Token.TYPE.T_TEXT], Token.TYPE.T_TEXT, function(a) { return a.split('//')[1]; }],
			"getDepartement": [1, [Token.TYPE.T_TEXT], Token.TYPE.T_TEXT, function(a) { return a.split('//')[2]; }],
			"getRegion": [1, [Token.TYPE.T_TEXT], Token.TYPE.T_TEXT, function(a) { return a.split('//')[3]; }],
			"getInsee": [1, [Token.TYPE.T_TEXT], Token.TYPE.T_TEXT, function(a) { return a.split('//')[4]; }],
			"sqrt": [1, [Token.TYPE.T_NUMBER], Token.TYPE.T_NUMBER, function (a) { return Math.sqrt(a); }],
            "substr": [3, [Token.TYPE.T_TEXT, Token.TYPE.T_NUMBER, Token.TYPE.T_NUMBER], Token.TYPE.T_TEXT, function (a, b, c) {
                if (b > 0) {
                    b--;
                }
                return a.substr(b, c);
            }],
            "sum": [-1, [Token.TYPE.T_NUMBER], Token.TYPE.T_NUMBER, function (a) {
                var s = 0;
                $.each(a, function (i, v) {
                    if (v !== undefined) {
                        s += v;
                    }
                });
                return s;
            }],
            "tan": [1, [Token.TYPE.T_NUMBER], Token.TYPE.T_NUMBER, function (a) { return Math.tan(a); }],
            "tanh": [1, [Token.TYPE.T_NUMBER], Token.TYPE.T_NUMBER, function (a) { return Math.tanh(a); }],
            "titlecase": [1, [Token.TYPE.T_TEXT], Token.TYPE.T_TEXT, function (a) {
                return a.toLowerCase().replace(/^[\u00C0-\u1FFF\u2C00-\uD7FF\w]|[-\s][\u00C0-\u1FFF\u2C00-\uD7FF\w]/g, function (letter) {
                    return letter.toUpperCase();
                });
            }],
            "trim": [1, [Token.TYPE.T_TEXT], Token.TYPE.T_TEXT, function (a) { return $.trim(a); }],
            "ucfirst": [1, [Token.TYPE.T_TEXT], Token.TYPE.T_TEXT, function (a) { return a.replace(/(^[a-z])/, function (p) { return p.toUpperCase(); }); }],
            "upper": [1, [Token.TYPE.T_TEXT], Token.TYPE.T_TEXT, function (a) { return a.toUpperCase(); }],
            "workdays": [2, [Token.TYPE.T_DATE, Token.TYPE.T_DATE], Token.TYPE.T_NUMBER, function (a, b) { return a.workingDaysBefore(b); }],
            "workdaysofmonth": [2, [Token.TYPE.T_NUMBER, Token.TYPE.T_NUMBER], Token.TYPE.T_NUMBER, function (a, b) {
                var d1 = DateG6k.createFromFormat('Y-n-j', a + '-' + b + '-1');
                var d2 = new Date(d1.getFullYear(), d1.getMonth() + 1, 0);
                return d1.workingDaysBefore(d2);
            }],
            "year": [1, [Token.TYPE.T_DATE], Token.TYPE.T_NUMBER, function (a) { return a.getFullYear(); }]
        };
        if (func.value === "defined") {
            if (args.length < 1) {
                throw new Error("Illegal number (" + args.length + ") of operands for function" + func);
            }
            var arg = args.pop();
            if (arg.isVariable()) {
                return new Token(Token.TYPE.T_BOOLEAN, false);
            }
            if (typeof arg.value === "undefined" || arg.value === null || arg.value === "") {
                return new Token(Token.TYPE.T_BOOLEAN, false);
            }
            return new Token(Token.TYPE.T_BOOLEAN, true);
        }
        if (typeof functions[func.value] === "undefined" || functions[func.value] === null) {
            throw new Error("Unknown function : " + func);
        }
        var argc = functions[func.value][0];
        var variableArgsCount = false;
        if (argc == -1) {
            argc = func.arity;
            variableArgsCount = true;
        }
        if (args.length < argc) {
            throw new Error("Illegal number (" + args.length + ") of operands for function" + func);
        }
        var argv = [];
        for (; argc > 0; --argc) {
            var arg = args.pop();
            if (!variableArgsCount) {
                if (arg.isVariable()) {
                    return new Token(Token.TYPE.T_UNDEFINED, [arg]);
                }
                var type = functions[func.value][1][argc - 1];
                if (type == Token.TYPE.T_TEXT && (arg.type == Token.TYPE.T_NUMBER || arg.type == Token.TYPE.T_DATE)) {
                    arg.value += '';
                } else if (arg.type != type) {
                    var expected = "";
                    switch (type) {
                        case Token.TYPE.T_NUMBER:
                            expected = "number";
                            break;
                        case Token.TYPE.T_DATE:
                            expected = "date";
                            break;
                        case Token.TYPE.T_BOOLEAN:
                            expected = "boolean";
                            break;
                        case Token.TYPE.T_TEXT:
                            expected = "text";
                            break;
                        case Token.TYPE.T_ARRAY:
                            expected = "array";
                            break;
                    }
                    throw new Error("Illegal type for argument '" + arg + "' : operand must be a " + expected + " for " + func);
                }
            } else if (arg.isVariable()) {
                if (func.value == 'sum' || func.value == 'count' || func.value == 'concat') {
                    arg.value = undefined;
                } else {
                    return new Token(Token.TYPE.T_UNDEFINED, [arg]);
                }
            }
            argv.unshift(arg.value);
        }
        if (variableArgsCount) {
            argv = [argv];
        }
        return new Token(functions[func.value][2], functions[func.value][3].apply(this, argv));
    }
};
